import React from "react";
import AdAssetsPage from "@/pages/admin-dashboard/AdAssetsPage";

const AdvertisingModule: React.FC = () => {
  return <AdAssetsPage />;
};

export default AdvertisingModule;
